import {
    ISearch,
    ISearchProfile,
    ISearchProvider,
    HorizAlignment,
    SearchProviderFieldType,
    ISearchProviderField, ISearchRequestSubset
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch, ISearchRequest} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import * as _ from 'lodash'
import {ColumnNodeProvider} from "../PA.UIM.Core/SearchTreeUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

const vUI_DomainItem_Search_Fields: {[id:string]: ISearchProviderField } = {
    WB_DOMITEM_ID:                {type: SearchProviderFieldType.number, renderOptions: { columnName: 'WB Domain Item Id', columnResourceName: 'colDomainItemId', alignment: HorizAlignment.Center}, domainOptions: {}},
    DOMAIN_ID:                    {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Domain Id', columnResourceName: 'colDomainId', alignment: HorizAlignment.Right}, domainOptions: {}},
    DOMAIN_ITEM_ID:               {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Domain Item Id', columnResourceName: 'colDomainItemId', alignment: HorizAlignment.Right}, domainOptions: {}},
    DOMAIN_ITEM_NAME:             {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Domain Item Name', columnResourceName: 'colDomainItemName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}}
}



const DomainItemSearchProviderBasic: ISearchProvider = {

    keyFields: {id:    'WB_DOMITEM_ID',
                id_ui: 'DOMAIN_ITEM_ID',
                name:  'DOMAIN_ITEM_NAME'},


    searchProviderFields: vUI_DomainItem_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_DOMItem_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }
}


const DomainItemSearchProfileBasic: ISearchProfile = {
    profileId: "default",
    profileName: "Domain",
    renderOptions: { ui5ResourceId: "DOMItemSearchProfileByName" },

    profileFilter: [
        {profileFilterName: 'Domain Id',     searchProviderFieldId: 'DOMAIN_ID', renderOptions: {DOMAIN_ID: 'UserRole' }},
        {profileFilterName: 'Item Id',       searchProviderFieldId: 'DOMAIN_ITEM_ID', renderOptions: { }},
        {profileFilterName: 'Item Name',     searchProviderFieldId: 'DOMAIN_ITEM_NAME', renderOptions: { }}
    ],  // ISearchFields
    profileDisplayFields: [
        'DOMAIN_ID','DOMAIN_ITEM_NAME','DOMAIN_ITEM_ID'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileTreeIdDefault: "default",
    profileTrees: [
        {treeId: "default",
            treeName: "By Domain",
            nodeProviders: [new ColumnNodeProvider(['DOMAIN_ID'], {defaultValues: "Domain not set", levelDelimiter: "\\", ruggedTree: true})],
            renderOptions: {ui5: {}}}
    ],


    profileSearchProvider: DomainItemSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}

const vUI_DomainItem_User_Role_Search_Fields: {[id:string]: ISearchProviderField } = {
    WB_DOMITEM_ID:                {type: SearchProviderFieldType.number, renderOptions: { columnName: 'WB Domain Item Id', columnResourceName: 'colDomainItemId', alignment: HorizAlignment.Center}, domainOptions: {}},
    DOMAIN_ID:                    {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Domain Id', columnResourceName: 'colDomainId', alignment: HorizAlignment.Right}, domainOptions: {}},
    DOMAIN_ITEM_ID:               {type: SearchProviderFieldType.string, renderOptions: { columnName: 'User Role Id', columnResourceName: 'colUserRoleId', alignment: HorizAlignment.Right}, domainOptions: {}},
    DOMAIN_ITEM_NAME:             {type: SearchProviderFieldType.string, renderOptions: { columnName: 'User Role Name', columnResourceName: 'colUserRoleName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}}
}


const DomainItemSearchProviderUserRoles: ISearchProvider = {

    keyFields: {id:    'WB_DOMITEM_ID',
                id_ui: 'DOMAIN_ITEM_ID',
                name:  'DOMAIN_ITEM_NAME'},


    searchProviderFields: vUI_DomainItem_User_Role_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            if(_.isEmpty(searchOptions.where)){
                searchOptions.where = {DOMAIN_ID: 'User_Roles'}
            } else {
                searchOptions.where.DOMAIN_ID = 'User_Roles'
            }
            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
              'vUI_DOMItem_Search',
              this.searchProviderFields,
              [])

            PASearch.findByRequest(findRequest)
              .then((res: any[]) => {
                  resolve(res)
              })
              .catch((err)=> {
                  error(err)
              })
        })
    }
}



const DomainItemSearchProfile_UserRoles: ISearchProfile = {
    profileId:   "UserRole",
    profileName: "User Role",
    renderOptions: { ui5ResourceId: "DOMItemSearchProfileByName" },

    profileFilter: [
        {profileFilterName: 'User Role Id',     searchProviderFieldId: 'DOMAIN_ITEM_ID', renderOptions: { }},
        {profileFilterName: 'User Role Name',   searchProviderFieldId: 'DOMAIN_ITEM_NAME', renderOptions: { }}
    ],  // ISearchFields
    profileDisplayFields: [
        'DOMAIN_ITEM_NAME','DOMAIN_ITEM_ID'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileTreeIdDefault: "default",
    profileTrees: [
        {treeId: "default",
            treeName: "By User Roles",
            nodeProviders: [new ColumnNodeProvider(['DOMAIN_ID'], {defaultValues: "User Role Group not set", levelDelimiter: "\\", ruggedTree: true})],
            renderOptions: {ui5: {}}}
    ],

    profileSearchProvider: DomainItemSearchProviderUserRoles,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}

//DOMItemSearch


var DomainItemSearch: ISearch = {
    ProfileId_DomainSearch:   "default",
    ProfileId_UserRoleSearch: "UserRole",

    searchName: "Find Item",
    renderOptions: { ui5ResourceId: "DomainItemSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [DomainItemSearchProfileBasic, DomainItemSearchProfile_UserRoles]
}
PAEnvironment.registerBusinessObjectSearch("DomainItemBO", "DomainItem", DomainItemSearch, "Domain Item Search")
export {DomainItemSearch}